<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 mb-2">
      <div class="breadcrumb-title mb-3 mt-md-0 mt-4">
        <div class="d-flex align-items-center">
          <mat-icon color="primary">account_balance</mat-icon>
          <p class="ms-2 mb-0">{{ "organization.title" | translate }}</p>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="card mb-3">
        <form class="p-3 p-lg-4" #uiForm="ngForm">
          <div class="mb-4" *ngIf="form['message']">
            <app-ncs-alert
              *ngIf="form['error'] == false"
              [message]="form['message']"
              type="success"
            />
            <app-ncs-alert
              *ngIf="form['error'] == true"
              [message]="form['message']"
              type="danger"
            />
          </div>
          <div class="row g-3 compact-inputs dropdown">
            <div class="col-12 mb-2">
              <h5 class="mb-1">
                {{ "organization.Organization_Details" | translate }}
              </h5>
              <p class="text-muted small">
                {{ "organization.Organization_Title" | translate }}
              </p>
            </div>
            <div class="col-md-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{
                  "organization.form.labels.name" | translate
                }}</mat-label>
                <span matPrefix class="me-2 text-muted"
                  ><i class="fa fa-building-o"></i> &nbsp;</span
                >
                <input
                  matInput
                  required
                  (input)="checkValueName($event)"
                  [(ngModel)]="form.data['name']"
                  name="name"
                />
                <mat-error
                  *ngIf="
                    form.inputerror['name'] || uiForm.controls['name']?.invalid
                  "
                >
                  {{
                    form.inputerror["name"] ||
                      ("organization.form.errors.required" | translate)
                  }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{
                  "organization.form.labels.phone" | translate
                }}</mat-label>
                <input
                  matInput
                  type="tel"
                  required
                  pattern="^[0-9]{10}$"
                  [(ngModel)]="form.data['phone']"
                  name="phone"
                  #phone="ngModel"
                  oninput="
                    this.value = this.value.replace(/[^0-9]/g, '').slice(0, 10)
                  "
                />
                <mat-error
                  *ngIf="
                    uiForm.submitted &&
                    (uiForm.controls['phone']?.errors?.['required'] ||
                      phone.errors?.['pattern'])
                  "
                >
                  {{ "organization.form.errors.phonePattern" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{
                  "organization.form.labels.description" | translate
                }}</mat-label>
                <textarea
                  matInput
                  required
                  rows="3"
                  (input)="checkValueDescription($event)"
                  [(ngModel)]="form.data['address']"
                  name="address"
                ></textarea>
                <mat-error
                  *ngIf="
                    form.inputerror['address'] ||
                    uiForm.controls['address']?.invalid
                  "
                >
                  {{ form.inputerror["address"] }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-12" *ngIf="form.data['id'] > 0">
              <label
                class="mat-body-strong d-block mb-2 text-secondary fw-bold small text-uppercase"
              >
                {{ "organization.form.labels.logo" | translate }}
              </label>

              <div class="d-flex flex-column gap-3">
                <div
                  class="position-relative me-4 border rounded overflow-hidden d-flex align-items-center justify-content-center"
                  style="width: 200px; height: 200px"
                >
                  <img
                    [src]="
                      imagePreview == null
                        ? getDoc(form.data['logoId'])
                        : imagePreview
                    "
                    alt="Logo preview"
                    class="img-fluid"
                    style="object-fit: contain; width: 100%; height: 100%"
                  />
                </div>

                <div class="flex-grow-1">
                  <div class="d-flex gap-2">
                    <button
                      mat-stroked-button
                      color="primary"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#imageModal"
                      (click)="resetFileInput(file)"
                    >
                      <i class="fa fa-edit"></i>
                      {{ "organization.form.buttons.upload" | translate }}
                    </button>

                    <button
                      mat-stroked-button
                      color="warn"
                      type="button"
                      (click)="removeLogo()"
                    >
                      <i class="fa fa-eraser"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 mt-4 pt-3 border-top d-flex justify-content-end">
              <button
                mat-stroked-button
                color="primary"
                class=""
                [disabled]="
                  !uiForm.valid || organizationDescription || organizationName
                "
                (click)="save()"
              >
                <mat-icon>save</mat-icon>
                <span>{{ "organization.form.buttons.save" | translate }}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Image Update Modal -->
<div
  class="modal fade"
  id="imageModal"
  tabindex="-1"
  aria-labelledby="imageModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="imageModalLabel">
          {{ "organization.imageModal.title" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          (click)="cancelCropping()"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body compact-inputs dropdown-pd-none p-4">
        <mat-form-field
          appearance="outline"
          class="w-100 mt-2"
          floatLabel="always"
        >
          <mat-label>{{
            "organization.imageModal.labels.selectLogo" | translate
          }}</mat-label>

          <input
            #file
            type="file"
            id="logoId"
            name="logoId"
            accept="image/jpeg, image/jpg, image/png, image/gif"
            (click)="onFileChooseClicked(file)"
            (change)="
              file.files && onFileChanged($event, 'logoId', form.data['logoId'])
            "
            style="display: none"
          />

          <input
            matInput
            readonly
            [value]="
              file.files && file.files.length > 0 ? file.files[0].name : ''
            "
            (click)="file.click()"
            [placeholder]="
              'organization.imageModal.labels.selectLogo' | translate
            "
            style="cursor: pointer"
          />

          <button
            mat-icon-button
            matSuffix
            (click)="file.click()"
            class="icon-pd-none"
            type="button"
          >
            <mat-icon class="text-secondary icon-compact">attach_file</mat-icon>
          </button>

          <mat-error *ngIf="fileError">
            {{ "organization.form.errors.fileType" | translate }}
          </mat-error>
          <mat-error *ngIf="imageSize">
            {{ "organization.form.errors.fileSize" | translate }}
          </mat-error>
        </mat-form-field>

        <div class="button-row my-3 d-flex flex-wrap gap-2" *ngIf="showCropper">
          <button
            mat-stroked-button
            color="primary"
            (click)="zoomIn()"
            class="btn-sm"
          >
            <mat-icon>zoom_in</mat-icon>
            <small>{{
              "organization.imageModal.buttons.zoomIn" | translate
            }}</small>
          </button>

          <button
            mat-stroked-button
            color="primary"
            (click)="zoomOut()"
            class="btn-sm"
          >
            <mat-icon>zoom_out</mat-icon>
            <small>{{
              "organization.imageModal.buttons.zoomOut" | translate
            }}</small>
          </button>

          <button
            mat-stroked-button
            color="primary"
            (click)="rotateRight()"
            class="btn-sm"
          >
            <mat-icon>rotate_right</mat-icon>
            <small>{{
              "organization.imageModal.buttons.rotateRight" | translate
            }}</small>
          </button>

          <button
            mat-stroked-button
            color="primary"
            (click)="rotateLeft()"
            class="btn-sm"
          >
            <mat-icon>rotate_left</mat-icon>
            <small>{{
              "organization.imageModal.buttons.rotateLeft" | translate
            }}</small>
          </button>

          <button
            mat-stroked-button
            color="primary"
            (click)="flipHorizontal()"
            [class.enabled]="transform.flipH"
            class="btn-sm"
          >
            <mat-icon>flip</mat-icon>
            <small>{{
              "organization.imageModal.buttons.flipHorizontal" | translate
            }}</small>
          </button>

          <button
            mat-stroked-button
            color="primary"
            (click)="flipVertical()"
            [class.enabled]="transform.flipV"
            class="btn-sm"
          >
            <mat-icon style="transform: rotate(90deg)">flip</mat-icon>
            <small>{{
              "organization.imageModal.buttons.flipVertical" | translate
            }}</small>
          </button>
        </div>

        <div class="row preview-row">
          <div class="col-12">
            <div class="cropper-wrapper">
              <image-cropper
                [imageChangedEvent]="imageChangedEvent"
                [imageURL]="imageURL"
                [hidden]="hidden"
                [disabled]="disabled"
                [alignImage]="alignImage"
                [roundCropper]="roundCropper"
                [backgroundColor]="backgroundColor"
                imageAltText="Alternative image text"
                [allowMoveImage]="allowMoveImage"
                [hideResizeSquares]="hideResizeSquares"
                [canvasRotation]="canvasRotation"
                [aspectRatio]="aspectRatio"
                [containWithinAspectRatio]="containWithinAspectRatio"
                [maintainAspectRatio]="maintainAspectRatio"
                [cropperStaticWidth]="cropperStaticWidth"
                [cropperStaticHeight]="cropperStaticHeight"
                [cropperMinWidth]="cropperMinWidth"
                [cropperMinHeight]="cropperMinHeight"
                [cropperMaxWidth]="cropperMaxWidth"
                [cropperMaxHeight]="cropperMaxHeight"
                [resetCropOnAspectRatioChange]="resetCropOnAspectRatioChange"
                [(transform)]="transform"
                [onlyScaleDown]="true"
                format="png"
                (imageCropped)="imageCropped($event)"
                (imageLoaded)="imageLoaded()"
                (cropperReady)="cropperReady($event)"
                (loadImageFailed)="loadImageFailed()"
                (transformChange)="transformChange($event)"
                [style.display]="showCropper ? 'block' : 'none'"
                output="base64"
              >
              </image-cropper>
            </div>
          </div>

          <div class="col-12" *ngIf="showCropper">
            <div class="preview-card">
              <h6 class="fw-bold">
                {{ "organization.imageModal.preview" | translate }}
              </h6>
              <div class="text-center">
                <img
                  *ngIf="croppedImage"
                  [src]="croppedImage"
                  class="cropped-preview"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="primary"
          type="button"
          [disabled]="!croppedImage"
          (click)="saveCroppedImage()"
          [attr.data-bs-dismiss]="!imageSize ? 'modal' : null"
        >
          <mat-icon class="me-1">save</mat-icon>
          {{ "organization.imageModal.buttons.save" | translate }}
        </button>
        <button
          mat-stroked-button
          color="warn"
          type="button"
          (click)="cancelCropping()"
          data-bs-dismiss="modal"
          [title]="'organization.imageModal.buttons.close' | translate"
        >
          <mat-icon class="me-1">close</mat-icon>
          {{ "organization.imageModal.buttons.close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
